<template>
  <div class="login-register-modal-mobile">
    <div class="d-modal-close fas fa-times" @click="close"></div>
    <div
      :class="
        signUp
          ? 'modal-register-content modal-register-content__opened'
          : 'modal-register-content'
      "
    >
      <div class="register-content__form-wrapper">
        <register-form @close="close" @send="setSubmitted"></register-form>
        <div v-if="!submitted" class="signup-button-wrapper">
          <p class="small-text">Already have an account?</p>
          <a class="form-wrapper__link" @click="toggleOption">LOGIN</a>
        </div>
      </div>
    </div>
    <div
      :class="
        !signUp
          ? 'modal-login-content modal-login-content__opened'
          : 'modal-login-content'
      "
    >
      <div class="login-content__form-wrapper">
        <login-form @close="close" @send="setSubmitted"></login-form>
        <div v-if="!submitted" class="signup-button-wrapper">
          <p class="small-text">Don't have an account yet?</p>
          <a class="form-wrapper__link" @click="toggleOption">SIGNUP</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginForm from "./login-form";
import SocialLogin from "./social-login";
import RegisterForm from "./register-form";
import HorizontalLineWithTextInside from "./horizontal-line-with-text-inside";

export default {
  name: "login-register-modal-mobile",
  components: {
    HorizontalLineWithTextInside,
    LoginForm,
    SocialLogin,
    RegisterForm
  },
  props: {
    type: {
      type: Boolean
    }
  },
  data: function() {
    return {
      signUp: false,
      submitted: false
    };
  },
  methods: {
    toggleOption: function() {
      this.signUp = !this.signUp;
    },
    close: function() {
      this.$emit("close");
    },
    setSubmitted: function() {
      this.submitted = true;
    }
  },
  mounted() {
    this.signUp = this.type;
  },
  watch: {
    type: {
      handler: function(oValue, nValue) {
        this.signUp = nValue;
      }
    }
  }
};
</script>
<style lang="scss">
.login-register-modal-mobile {
  text-transform: none;
  text-align: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  width: 100vw;
  background: white;
  .d-modal-close {
    color: #0f74bd !important;
  }

  .modal-register-content {
    transform: translateY(-100%);
    margin-top: 0;
    padding-top: 3rem;
    height: 100vh;
    transition: 0.5s;

    &__opened {
      transform: translateY(0);
    }

    .register-content {
      &__form-wrapper {
        background-color: white;
        color: #999999;
        margin-top: 4rem;

        .form-wrapper {
          &__title {
            color: #333333;
            font-size: 24px;
            font-weight: bold;
          }
        }
      }
    }
  }

  .modal-login-content {
    transform: translateY(100%);
    margin-top: 0;
    padding-top: 3rem;
    height: 100vh;
    transition: 0.5s;

    &__opened {
      transform: translateY(-100%);
    }

    .login-content {
      &__form-wrapper {
        background-color: white;
        color: #999999;
        margin-top: 4rem;
        .form-wrapper {
          &__title {
            color: #333333;
            font-size: 24px;
            font-weight: bold;
          }
        }
      }
    }
  }

  .signup-button-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 1rem;
    color: black;
    p {
      margin: 0;
    }
    .form-wrapper__link {
      color: #0075b4;
      margin-left: 0.5rem;
    }
  }
}
.small-text {
  &--left {
    font-size: 12px;
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/login-register-modal-mobile.vue